import bFormFile from './form-file';
import { registerComponents, vueUse } from '../../utils/plugins';

var components = {
  bFormFile: bFormFile,
  bFile: bFormFile
};

var VuePlugin = {
  install: function install(Vue) {
    registerComponents(Vue, components);
  }
};

vueUse(VuePlugin);

export default VuePlugin;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/form-file/index.js
// module id = dOJo
// module chunks = 8